import React, { useState } from "react";
import Card from "src/components/Cards/Basic";
import { Tab, Tabs } from "react-bootstrap";
import AccessKeySection from "../../../AccessKeys/AccessKeySection";
import AccessSystemSection from "../../../AccessKeys/AccessSystemSection";
import Holidays from "../Holidays";

const BookingPlannerSettingsPage = () => {
  const [activeTab, setActiveTab] = useState("holidays");
  return (
    <Tabs activeKey={activeTab} onSelect={(tab) => setActiveTab(tab)}>
      <Tab title={"Feiertage"} eventKey={"holidays"}>
        {activeTab === "holidays" && <Holidays />}
      </Tab>
    </Tabs>
  );
};

export default BookingPlannerSettingsPage;
